import { ControllerRenderProps, MultiSelect, MultiSelectOption } from '@otp/ui';
import { Permission } from 'src/graphql/generated/graphql';
import { usePermissions } from 'src/hooks/query/use-permissions';

type PermissionsProps = {
  field: ControllerRenderProps<any, any>;
  className?: string;
  permissionMap?: (item: Pick<Permission, 'name' | 'id'>) => MultiSelectOption;
  multiple?: boolean;
};

export const PermissionsField = ({
  field,
  className,
  permissionMap = (permission) => ({
    value: permission.id,
    name: permission.name || '',
  }),
  multiple = false,
}: PermissionsProps) => {
  // ToDo: use Milos on-demand loader
  const { data: permissions } = usePermissions({
    pagination: { limit: 10000, page: 0 },
  });

  const permissionOptions = permissions
    .map(permissionMap)
    .filter((option) => option.name);

  if (!permissionOptions.length) {
    return null;
  }

  return (
    <MultiSelect
      multiple={multiple}
      key={field.value}
      fullWidth={true}
      className={className}
      options={permissionOptions}
      defaultValue={field.value}
      {...field}
      value={undefined}
      ref={undefined}
    />
  );
};
